import LocalStorageManager from './../../utils/LocalStorageManager'
import AuthActions from './actions'
import UserMiddleware from './../user/middleware'
import request, { setToken, setCompanyToken, userApplicationId } from './../../utils/requestConfig'
import message from './../../locales/pt-BR'

export default class AuthMiddleware {
  // Signin Functions Starts
  static signin (credentials) {
    return (dispatch) => {
      dispatch(AuthActions.signin())
      AuthMiddleware.signinWithUserCredentials(dispatch, credentials)
    }
  }

  static signinWithUserCredentials (dispatch, credentials) {
    if (credentials) {
      request.post('/users/auth', {
        ...userApplicationId,
        login: credentials.email,
        password: btoa(credentials.password)
      })
        .then(function (response) {
          const data = response.data
          const { token } = response.data
          const {company_token} = response.data
          LocalStorageManager.setUserToken(token)
          LocalStorageManager.setCompanyToken(company_token)
          LocalStorageManager.setUser(data)
          setToken(token)
          setCompanyToken(company_token)
          dispatch(AuthActions.signinSuccessful(data))
          dispatch(AuthMiddleware.getRoles())
        })
        .catch(function () {
          dispatch(AuthActions.signinRejected(message.auth.signinRejected))
        })
    } else {
      dispatch(AuthActions.signinRejected('error no credentials'))
    }
  }
  // Signin Functions Ends

  // Logout Functions Starts
  static logout () {
    return (dispatch) => {
      request.post('/users/logout')
        .then(function () {
          dispatch(AuthActions.logout())
          dispatch(UserMiddleware.clearUser())
          AuthMiddleware.logoutFromAPI(dispatch)
        })
        .catch(function () {
          dispatch(AuthActions.signinRejected(message.auth.invalidToken))
        })
    }
  }
  static logoutFromAPI (dispatch) {
    LocalStorageManager.removeUserToken()
    LocalStorageManager.removeUser()
    LocalStorageManager.removeCompanyToken()
    LocalStorageManager.clearLocalStorage()
    dispatch(AuthActions.logoutSuccessful())
  }
  // Logout Functions Ends

  static getRoles () {
    return (dispatch) => {
      dispatch(AuthActions.getRoleRequest())
      request.get('/roles/application_user_roles', {
        params: {
          ...userApplicationId
        }
      })
        .then(function ({ data }) {
          dispatch(AuthActions.getRoleSuccessful(data.data[0]))
        })
        .catch(function () {
          dispatch(AuthActions.getRoleRejected(message.auth.invalidToken))
        })
    }
  }

  // isLoggedIn
  static isLoggedIn () {
    return (dispatch) => {
      const token = LocalStorageManager.getUserToken()
      if (token) {
        AuthMiddleware.ensureAuthenticated(dispatch, token)
      } else {
        dispatch(AuthActions.isLoggedInFailure())
      }
    }
  }

  // ensureAuthenticated
  static ensureAuthenticated (dispatch, token) {
    if (token) {
      // has set user because refresh page
      dispatch(AuthActions.isLoggedInSuccess(LocalStorageManager.getUser()))
    } else {
      // never gonna happen
      dispatch(AuthActions.signinRejected('no token'))
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/auth/middleware.js